import { useSearch } from './hooks';

type Args = {
  /** 検索ボタンがクリックされたときに呼び出される関数。 */
  onSearch: (searchValue: string) => void;
  /** 検索フィールドの値。 */
  searchValue: string;
  /** 検索フィールドの値を設定する関数。 */
  setSearchValue: (searchValue: string) => void;
};

/** 検索機能のコンポーネント。 */
export const Search = ({ onSearch, searchValue, setSearchValue }: Args) => {
  const { handleChangeSearchField, handleClickClearButton, handleKeyDown } =
    useSearch({ onSearch, searchValue, setSearchValue });

  return (
    <div className="flex items-center w-full border border-outline rounded-[4px] bg-surface px-[16px] py-[12px]">
      <MagnifyingGlassIcon />
      <input
        type="text"
        placeholder="絞り込み検索"
        value={searchValue}
        onChange={handleChangeSearchField}
        onKeyDown={handleKeyDown}
        className="flex-1 mx-[16px] noto-sans-jp-regular text-[16px] text-textPrimary placeholder-textSecondary border-none focus:outline-none"
      />
      <button
        type="button"
        className="text-gray-400 hover:text-gray-600"
        onClick={handleClickClearButton}
      >
        <ClearIcon />
      </button>
    </div>
  );
};

const MagnifyingGlassIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
        stroke="#858688"
      />
    </svg>
  );
};

const ClearIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
        stroke="#858688"
      />
    </svg>
  );
};
